<template>
    <div class="element-wrapper">
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col text-center" v-if="avaliacoes.length == 0">
              <h5>Não há avaliações realizadas para essa rede.</h5>
            </div>
            <div class="col-sm-4 col-xxxl-3" v-else v-for="avaliacao in avaliacoes" :key="avaliacao._id">
              <div class="element-box el-tablo profile-tile-box">
                <div class="row">
                  <div class="col-4">
                    <div class="user-avatar">
                      <img alt="" src="@/img/icon-drachei-alpha.svg" class="img-fluid rounded-circle">
                    </div>
                  </div>
                  <div class="col">
                    <div class="label">
                      {{ avaliacao.servico }}
                    </div>
                    <h6> {{ avaliacao.descricao }} </h6>
                    <span class="blockquote-footer">
                      {{ avaliacao.cliente.name}}, {{ getDataFormatada(avaliacao.createdAt) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as redeService from '@/store/rede/services'
import moment from 'moment'

export default {
  created () {
    moment.locale('pt-br')
  },
  data () {
    return {
      avaliacoes: []
    }
  },
  mounted () {
    redeService.getAvaliacoes(this.$route.query.idRede)
      .then(response => {
        this.avaliacoes = response.data
      })
  },

  methods: {
    getDataFormatada (date) {
      return moment(date).format('DD/MM/YYYY')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/single-consultorio/ReviewsTab.vue